import { useCallback } from 'react';
import { FieldPath } from 'react-hook-form';

import { useJobPostingContext } from '@/contexts/job-posting-context';

import { JobPostingForm } from '../../types';
import { baseFields } from '../../validation/job-details-schema';

/**
 * Returns a stable callback that triggers RHF validation for all base
 * (common) job-detail fields across every opening currently in the form.
 *
 * Intentionally excludes `vonqPostingRequirements` so that posting-requirement
 * errors don't surface until the user visits that section.
 */
export function useValidateBaseFields() {
  const { hookForm } = useJobPostingContext();
  const { trigger, getValues } = hookForm;

  return useCallback(() => {
    const openingIds = Object.keys(getValues('jobDetails') ?? {});
    return trigger(
      openingIds.flatMap(openingId =>
        (Object.keys(baseFields) as (keyof typeof baseFields)[]).map(
          field =>
            `jobDetails.${openingId}.${field}` as FieldPath<JobPostingForm>,
        ),
      ),
    );
  }, [trigger, getValues]);
}
